"use strict";
/**
 * @param elementToObserve the element to observe (must contain the element we wish to find)
 * @param findSelector query selector of the element to find
 *
 * https://stackoverflow.com/a/61511955
 */
window.findElementOnceItExists = function (elementToObserve, findSelector) {
    return new Promise(function (resolve) {
        // if we can find the element right away, don't bother with a mutation observer
        var el = elementToObserve.querySelector(findSelector);
        if (el) {
            resolve(el);
            return;
        }
        var observer = new MutationObserver(function () {
            var element = elementToObserve.querySelector(findSelector);
            if (element) {
                observer.disconnect();
                resolve(element);
                return;
            }
        });
        observer.observe(elementToObserve, { childList: true, subtree: true });
    });
};
